import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import NumberFormat from 'react-number-format';

import { numberFormat } from 'constants/formats';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import { useSharesTransferModal } from '../context/SharesTransferModalContext';

const PriceView: FC = () => {
  const { t } = useTranslate();
  const animatedComponents = makeAnimated();
  const { data, actions } = useSharesTransferModal();

  return (
    <div className="row mb-4">
      <div className="col-6">
        <div className="form-group">
          <label className="form-label" htmlFor="price">
            {data.selectedPriceTypeOption?.label} <MandatoryField />
          </label>
          <div className="form-control-wrap">
            <NumberFormat
              id="price"
              className="form-control form-control-lg"
              value={data.price}
              onChange={actions.handleChangePrice}
              thousandSeparator={numberFormat.thousandSeparator}
              decimalSeparator={numberFormat.decimalSeparator}
              allowNegative={false}
              decimalScale={10}
              required
            />
          </div>
        </div>
      </div>

      <div className="col-6">
        <div className="form-group">
          <label className="form-label" htmlFor="default-01">
            {t('PriceType')}
          </label>
          <div className="form-control-wrap">
            <Select
              closeMenuOnSelect
              className="react-select react-select-lg"
              value={data.selectedPriceTypeOption}
              options={data.priceTypeOptions}
              components={animatedComponents}
              onChange={actions.handleChangePriceType}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceView;
